import { Children, useEffect, useState } from "react"

import {
  Paper,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
  Divider,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  Typography,
} from "@mui/material"

import StartCaseIcon from "@mui/icons-material/StartOutlined"
import MeshEditIcon from "@mui/icons-material/CategoryOutlined"
import ChairsideIcon from "@mui/icons-material/QuickreplyOutlined"
import QuickSetupIcon from "@mui/icons-material/Settings"
import QuickStagingIcon from "@mui/icons-material/RouteOutlined"
import QuickAuxIcon from "@mui/icons-material/AttachmentOutlined"
import ReviewModIcon from "@mui/icons-material/TouchAppOutlined"
import WeSetupIcon from "@mui/icons-material/Settings"
import WeStagingIcon from "@mui/icons-material/RouteOutlined"
import WeAttIcon from "@mui/icons-material/AttachmentOutlined"
import RxIcon from "@mui/icons-material/BookOutlined"
import QuickRxIcon from "@mui/icons-material/BookOutlined"
import OrderIcon from "@mui/icons-material/AddShoppingCartOutlined"
import WePrintingIcon from "@mui/icons-material/Print"
import WeTestIcon from "@mui/icons-material/PestControl"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { setCurRightPage, setOpenBiteCheck } from "../udTreatSlice"
import { useTheme } from "@mui/material/styles"
import {
  EArchType,
  toothMovement,
  viewControlInTreatment,
  wasmModule,
} from "@/gluelayer"

import NewAuxIcon from "../assets/right/attachment.svg"
import NewArchIcon from "../assets/right/arch_adjustment.svg"
import NewVerticalIcon from "../assets/right/vertical_adjustment.svg"

import { styled } from "@mui/material/styles"
import { TooltipProps, tooltipClasses } from "@mui/material/Tooltip"

import { ReactSVG } from "react-svg"
import { WePrinting } from "../WeDesign/WePrinting/WePrinting"
import SetupIcon from "../assets/right/setup.svg"
import StagingIcon from "../assets/right/staging.svg"
import AuxIcon from "../assets/right/auxillary.svg"

export function RightToolBar(props: any) {
  const theme = useTheme()
  const {
    curCaseMode,
    curRightPage,
    switchViewEdit,
    ucloud1_1,
    isOpenModelCheck,
    isDoingPresetup,
    tpProtectionStatus
  } = useAppSelector((state: RootState) => state.udTreatService)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)

  const dispatch = useAppDispatch()
  const [fastsmartAlert, setFastsmartAlert] = useState(false)
  const { curArch, openHistorySplitView, openBiteCheck } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    nextTool: string,
  ) => {
    if (nextTool === "fastsmart" || nextTool === "finetune") {
      const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
      const hasLower = wasmModule.getArchModel(EArchType.LowArch)

      if (hasUpper && hasLower && curArch === "all") {
        setFastsmartAlert(true)
        return
      }
    }

    dispatch(setCurRightPage(nextTool))

    if (!wasmModule.isInit) return
    if (nextTool === "fastsmart") {
      if (openBiteCheck) {
        dispatch(setOpenBiteCheck(false))
        viewControlInTreatment.setOcclusionVisibility(false)
      }

      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(true)
    } else if (nextTool === "finetune") {
      if (openBiteCheck) {
        dispatch(setOpenBiteCheck(false))
        viewControlInTreatment.setOcclusionVisibility(false)
      }
      viewControlInTreatment.setOcclusionVisibility(false)
      toothMovement.switchModuleFastSmartCircle(false)
      toothMovement.switchModuleFineTuneCircle(true)
    } else {
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }
  }

  useEffect(() => {
    if (openBiteCheck) {
      if (curRightPage === "fastsmart" || curRightPage === "finetune") {
        dispatch(setCurRightPage(""))
      }
    }
  }, [openBiteCheck])

  useEffect(() => {
    dispatch(setCurRightPage(""))

    if (!switchViewEdit && tpProtectionStatus && wasmModule.isInit) {
      toothMovement.switchModuleFineTuneCircle(false)
      toothMovement.switchModuleFastSmartCircle(false)
    }
  }, [switchViewEdit, tpProtectionStatus])

  useEffect(() => {
    if (isOpenModelCheck) dispatch(setCurRightPage(""))
  }, [isOpenModelCheck])
  const ChairsideBtns = () => {
    return (
      <ToggleButtonGroup
        orientation="vertical"
        value={curRightPage}
        exclusive
        onChange={handleChange}
      >
        <Tooltip title="Chairside Setup" placement="left">
          <ToggleButton value="Chairside Setup">
            <ChairsideIcon />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    )
  }
  const SmartRxBtns = () => {
    return (
      <ToggleButtonGroup
        orientation="vertical"
        value={curRightPage}
        exclusive
        onChange={handleChange}
      >
        <Tooltip title="Smart Rx" placement="left">
          <ToggleButton value="SmartRx">
            <RxIcon />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    )
  }

  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "rgba(255,255,255,0.75)",
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 13,
    },
  }))

  const RightToolTipButton = ({ children, title, value }) => {
    return (
      <LightTooltip
        title={title}
        open={curRightPage === "" || !curRightPage}
        placement="left"
      >
        <ToggleButton value={value}>{children}</ToggleButton>
      </LightTooltip>
    )
  }

  const UDPlanBtns = () => {
    return (
      <ToggleButtonGroup
        orientation="vertical"
        value={curRightPage}
        exclusive
        onChange={handleChange}
      >
        <RightToolTipButton title="Setup Final" value="QuickSetup">
          <QuickSetupIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Stage Movement" value="QuickStaging">
          <QuickStagingIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Place Auxillary" value="QuickAux">
          <QuickAuxIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Prescription" value="QuickRx">
          <QuickRxIcon />
        </RightToolTipButton>
        {/** 
        <RightToolTipButton title="3D Printing" value="WePrinting">
          <WePrintingIcon />
        </RightToolTipButton>*/}
      </ToggleButtonGroup>
    )
  }
  const ReviewModBtns = () => {
    return (
      <ToggleButtonGroup
        orientation="vertical"
        value={curRightPage}
        exclusive
        onChange={handleChange}
      >
        <RightToolTipButton title="Setup Final" value="QuickSetup">
          <QuickSetupIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Stage Movement" value="QuickStaging">
          <QuickStagingIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Place Auxillary" value="QuickAux">
          <QuickAuxIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Prescription" value="QuickRx">
          <QuickRxIcon />
        </RightToolTipButton>
        {/* 
        <ToggleButtonGroup
          orientation="vertical"
          value={curRightPage}
          exclusive
          onChange={handleChange}
        >
          <Tooltip title="Smart Rx" placement="left">
            <ToggleButton value="SmartRx">
              <RxIcon />
            </ToggleButton>
          </Tooltip>
        </ToggleButtonGroup>
        <Tooltip title="Review & Mod." placement="left">
          <ToggleButton value="ReviewMod">
            <ReviewModIcon />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Order" placement="left">
          <ToggleButton value="Order">
            <OrderIcon />
          </ToggleButton>
        </Tooltip>*/}
      </ToggleButtonGroup>
    )
  }
  const WeDesignBtns = () => {
    return (
      <ToggleButtonGroup
        orientation="vertical"
        value={curRightPage}
        exclusive
        onChange={handleChange}
      >
        <RightToolTipButton title="Setup Final" value="QuickSetup">
          <QuickSetupIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Stage Movement" value="QuickStaging">
          <QuickStagingIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Place Auxillary" value="QuickAux">
          <QuickAuxIcon />
        </RightToolTipButton>
        <RightToolTipButton title="Prescription" value="QuickRx">
          <QuickRxIcon />
        </RightToolTipButton>
        <Box sx={{ height: "40px" }}></Box>
        <Divider />
        <RightToolTipButton title="WeDesign Setup" value="WeSetup">
          <WeSetupIcon />
        </RightToolTipButton>
        <RightToolTipButton title="WeDesign Staging" value="WeStaging">
          <WeStagingIcon />
        </RightToolTipButton>
        <Divider />
        <RightToolTipButton title="WeDesign Shape Edit" value="UDMeshEdit">
          <MeshEditIcon />
        </RightToolTipButton>
        <RightToolTipButton title="WeDesign Aux." value="WeAux">
          <WeAttIcon />
        </RightToolTipButton>

        <RightToolTipButton title="WeDesign 3D Printing" value="WePrinting">
          <WePrintingIcon />
        </RightToolTipButton>

        <RightToolTipButton title="WeDesign Test" value="WeTest">
          <WeTestIcon />
        </RightToolTipButton>
      </ToggleButtonGroup>
    )
  }

  const RightToolBar_ucloud2 = () => {
    return (
      <Paper
        sx={{
          right: 16,
          top: 98,
          backgroundColor: theme.transBkColor.light,
          maxHeight: `calc(100% - 114px)`,
          overflow: "auto",
          "::-webkit-scrollbar": {
            width: "1px",
          },
          position: "absolute",
        }}
        elevation={6}
      >
        <Stack direction="column">
          {curCaseMode == "NewCase" ? (
            <></>
          ) : curCaseMode == "UDPlan" ? (
            <UDPlanBtns />
          ) : curCaseMode == "UDModi" ? (
            <ReviewModBtns />
          ) : curCaseMode == "UDView" ? (
            <></>
          ) : curCaseMode == "WeDesign" ? (
            <WeDesignBtns />
          ) : (
            <></>
          )}
        </Stack>
      </Paper>
    )
  }

  const BtnsForUcloud2 = () => {
    return (
      <>
        <Tooltip title="Setup" placement="left">
          <ToggleButton
            value="QuickSetup"
            sx={{
              textTransform: "none",
              width: "48px",
              border: "none",
              flexWrap: "wrap",
              borderRadius: "8px",
              "&:hover": {
                borderRadius: "8px",
              },
              "&.Mui-selected": {
                borderRadius: "8px",
              },
              // marginTop: "8px",
            }}
          >
            <ReactSVG
              src={SetupIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                if (curRightPage === "QuickSetup") {
                  path?.setAttribute("fill", "#215ECD")
                  path?.setAttribute("fill-opacity", "1")
                }
                // else {
                //   path?.setAttribute("fill", "black")
                //   path?.setAttribute("fill-opacity", "0.56")
                // }
              }}
            ></ReactSVG>
            <Typography
              variant="inherit"
              sx={{ fontSize: "11px", color: "rgba(96, 96, 96, 1)" }}
            >
              Setup
            </Typography>
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Staging" placement="left">
          <ToggleButton
            value="QuickStaging"
            sx={{
              textTransform: "none",
              width: "48px",
              flexWrap: "wrap",
              border: "none",
              borderRadius: "8px",
              "&:hover": {
                borderRadius: "8px",
              },
              "&.Mui-selected": {
                borderRadius: "8px",
              },
            }}
          >
            <ReactSVG
              src={StagingIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                if (curRightPage === "QuickStaging") {
                  path?.setAttribute("fill", "#215ECD")
                  path?.setAttribute("fill-opacity", "1")
                }
                // else {
                //   path?.setAttribute("fill", "black")
                //   path?.setAttribute("fill-opacity", "0.56")
                // }
              }}
            ></ReactSVG>
            <Typography
              variant="inherit"
              sx={{ fontSize: "11px", color: "rgba(96, 96, 96, 1)" }}
            >
              Staging
            </Typography>
          </ToggleButton>
        </Tooltip>
        <Tooltip title="UD Auxillary" placement="left">
          <ToggleButton
            value="UDAux"
            sx={{
              textTransform: "none",
              width: "48px",
              flexWrap: "wrap",
              border: "none",
              borderRadius: "8px",
              "&:hover": {
                borderRadius: "8px",
              },
              "&.Mui-selected": {
                borderRadius: "8px",
              },
            }}
          >
            <ReactSVG
              src={AuxIcon}
              afterInjection={(svg) => {
                const path = svg.getElementsByTagName("path")[0]
                if (curRightPage === "UDAux") {
                  path?.setAttribute("fill", "#215ECD")
                  path?.setAttribute("fill-opacity", "1")
                }
                // else {
                //   path?.setAttribute("fill", "black")
                //   path?.setAttribute("fill-opacity", "0.56")
                // }
              }}
            ></ReactSVG>
            <Typography
              variant="inherit"
              sx={{ fontSize: "11px", color: "rgba(96, 96, 96, 1)" }}
            >
              Aux
            </Typography>
          </ToggleButton>
        </Tooltip>
      </>
    )
  }

  const RightToolBar_ucloud1_1 = () => {
    return (
      !openHistorySplitView &&
      !isOpenModelCheck && (
        <Paper
          sx={{
            right: 16,
            top: 180,
            backgroundColor: theme.transBkColor.light,
            maxHeight: `calc(100% - 114px)`,
            overflow: "auto",
            "::-webkit-scrollbar": {
              width: "1px",
            },
            position: "absolute",
            borderRadius: "8px",
          }}
          elevation={6}
        >
          {switchViewEdit && !isDoingPresetup && !tpProtectionStatus &&
            caseDetail.caseDisposition !== "ATTENTION_NEEDED" && (
              <ToggleButtonGroup
                orientation="vertical"
                value={curRightPage}
                exclusive
                onChange={handleChange}
              >
                <BtnsForUcloud2 />
                {/* <Tooltip title="UD Auxillary" placement="left">
                  <ToggleButton
                    value="UDAux"
                    sx={{
                      border: "none",
                      borderRadius: "8px",
                      "&:hover": {
                        borderRadius: "8px",
                      },
                      "&.Mui-selected": {
                        borderRadius: "8px",
                      },
                    }}
                  >
                    <ReactSVG
                      src={NewAuxIcon}
                      afterInjection={(svg) => {
                        const path = svg.getElementsByTagName("path")[0]
                        if (curRightPage === "UDAux") {
                          path?.setAttribute("fill", "#215ECD")
                          path?.setAttribute("fill-opacity", "1")
                        } else {
                          path?.setAttribute("fill", "black")
                          path?.setAttribute("fill-opacity", "0.56")
                        }
                      }}
                    ></ReactSVG>
                  </ToggleButton>
                </Tooltip>

                <Tooltip title="Arch Adjustment" placement="left">
                  <ToggleButton
                    value="fastsmart"
                    sx={{
                      border: "none",
                      borderRadius: "8px",
                      "&:hover": {
                        borderRadius: "8px",
                      },
                      "&.Mui-selected": {
                        borderRadius: "8px",
                      },
                    }}
                  >
                    <ReactSVG
                      src={NewArchIcon}
                      afterInjection={(svg) => {
                        const path = svg.getElementsByTagName("path")[0]
                        if (curRightPage === "fastsmart") {
                          path?.setAttribute("fill", "#215ECD")
                          path?.setAttribute("fill-opacity", "1")
                        } else {
                          path?.setAttribute("fill", "black")
                          path?.setAttribute("fill-opacity", "0.56")
                        }
                      }}
                    ></ReactSVG>
                  </ToggleButton>
                </Tooltip>
                <Tooltip title="Vertical Adjustment" placement="left">
                  <ToggleButton
                    value="finetune"
                    sx={{
                      border: "none",
                      borderRadius: "8px",
                      "&:hover": {
                        borderRadius: "8px",
                      },
                      "&.Mui-selected": {
                        borderRadius: "8px",
                      },
                    }}
                  >
                    <ReactSVG
                      src={NewVerticalIcon}
                      afterInjection={(svg) => {
                        const path = svg.getElementsByTagName("path")[0]
                        if (curRightPage === "finetune") {
                          path?.setAttribute("fill", "#215ECD")
                          path?.setAttribute("fill-opacity", "1")
                        } else {
                          path?.setAttribute("fill", "black")
                          path?.setAttribute("fill-opacity", "0.56")
                        }
                      }}
                    ></ReactSVG>
                  </ToggleButton>
                </Tooltip> */}
              </ToggleButtonGroup>
            )}
          <Dialog open={fastsmartAlert}>
            {/* <DialogTitle></DialogTitle> */}
            <DialogContent>
              Please select a single arch to use this function.
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setFastsmartAlert(false)
                }}
                sx={{
                  textTransform: "uppercase",
                }}
                size="medium"
                variant="contained"
              >
                OK
              </Button>
            </DialogActions>
          </Dialog>
        </Paper>
      )
    )
  }

  return ucloud1_1 || curCaseMode === "cloud1_1" ? (
    <RightToolBar_ucloud1_1 />
  ) : (
    <RightToolBar_ucloud2 />
  )
}
